import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createSetBasicPrioCommand } from '../../../api/commands/factory/createPrioCommands';
import { BasicPrioValue } from '../../../api/queries';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetBasicPrio extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetBasicPrio';

    public constructor(public cardId: string, public priority: BasicPrioValue) {
        super(SetBasicPrio.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetBasicPrio): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createSetBasicPrioCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetBasicPrio): void => {
    const card = state.subtasks.find((x) => x.id === action.cardId);

    card.basicPrioValue = action.priority;
    card.lastUpdatedAt = new Date();
};

//@ts-ignore
registerMiddleware(SetBasicPrio.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetBasicPrio.ACTION_TYPE, reducer);
